import * as THREE from 'three';
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { Water } from "three/examples/jsm/objects/Water.js";
import  gsap from 'gsap';

// BASIC RAW CODE-1
const sceneWidth = 700;
const sceneHeight = 700;
const minCameraY = 80; 
const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 1000);
camera.position.set(0, 100, 200);
const renderer = new THREE.WebGLRenderer({ antialias: true });
renderer.setSize(window.innerWidth, window.innerHeight);
document.body.appendChild(renderer.domElement);
let controls = new OrbitControls(camera, renderer.domElement);
renderer.setClearColor(0x87ceeb);
renderer.setPixelRatio( window.devicePixelRatio );
const listener = new THREE.AudioListener();
camera.add(listener);

const audioLoader = new THREE.AudioLoader();

// Load audio file
audioLoader.load('/waterfall.mp3', function (buffer) {

  const sound = new THREE.Audio(listener);
  sound.setBuffer(buffer);
  sound.setVolume(1);
  sound.setLoop(true);

  const audioSource = new THREE.Mesh(new THREE.BoxGeometry(1, 1, 1), new THREE.MeshBasicMaterial());
  audioSource.add(sound);
  scene.add(audioSource);
  
  sound.play();
});

// Define boundaries to restrict camera movement
const maxDistanceFromCenter = Math.min(sceneWidth, sceneHeight) * 0.5;
const minDistanceFromCenter = 1;
function updateCameraPosition() {
  const cameraPosition = camera.position.clone();
  const distanceFromCenter = Math.sqrt(cameraPosition.x ** 2 + cameraPosition.z ** 2);

  if (distanceFromCenter > maxDistanceFromCenter) {
    cameraPosition.normalize().multiplyScalar(maxDistanceFromCenter);
  } else if (distanceFromCenter < minDistanceFromCenter) {
    cameraPosition.normalize().multiplyScalar(minDistanceFromCenter);
  }
  if (cameraPosition.y < minCameraY) {
    cameraPosition.y = minCameraY;
  }
  camera.position.set(cameraPosition.x, cameraPosition.y, cameraPosition.z);
}

// Lighting
const directionalLight = new THREE.DirectionalLight(0xffe200, 0.5);
directionalLight.position.set(1, 1, 1); 
scene.add(directionalLight);
renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure = 2;

// Create particles
const particleCount = 1000;
const particles = new THREE.BufferGeometry();
const positions = new Float32Array(particleCount * 3);
const sizes = new Float32Array(particleCount);

for (let i = 0; i < particleCount; i++) {
  const index = i * 3;
  positions[index] = Math.random() * 700 - 350; 
  positions[index + 1] = 80;
  positions[index + 2] = Math.random() * 700 - 350; 
  sizes[i] = Math.random() * 20 + 5;
}
particles.setAttribute('position', new THREE.BufferAttribute(positions, 3));
particles.setAttribute('size', new THREE.BufferAttribute(sizes, 1));

const particleMaterial = new THREE.PointsMaterial({
  color: 0xFFFF00,
  sizeAttenuation: false, 
  size: 6,
  map: new THREE.TextureLoader().load('/particles.png'), 
  blending: THREE.AdditiveBlending, 
  depthWrite: false, 
  transparent: true,
  opacity: 0.85,
});
const particleSystem = new THREE.Points(particles, particleMaterial);
scene.add(particleSystem);

// Create the water surface
const waterGeometry = new THREE.PlaneGeometry(700, 700, 100, 100);
const waterMaterial = new THREE.MeshBasicMaterial({ color: 0x001e2d, transparent: true, opacity: 100 });
const water = new Water(waterGeometry, {
  textureWidth: 512,
  textureHeight: 512,
  waterNormals: new THREE.TextureLoader().load('./water1.jpg', function (texture) {
    texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
  }),
  alpha: 0.85, 
  sunDirection: new THREE.Vector3(1, -1, 1),
  sunColor: 0xffe200,
  waterColor: 0x001e2d,
  distortionScale: 7,
},waterMaterial);
water.position.y = 25;
water.rotation.x = - Math.PI / 2;
scene.add(water);

// sky
const dayColor = new THREE.Color(0x00BFFF);
const nightColor = new THREE.Color(0x000B18);
const skyMaterial = new THREE.MeshBasicMaterial({
  color: dayColor,
  side: THREE.BackSide,
});
const sky = new THREE.Mesh(new THREE.SphereGeometry(500, 32, 32), skyMaterial);
scene.add(sky);

const switchButton = document.getElementById('switch-button');
const sunIcon = document.querySelector('.fa-sun');
const moonIcon = document.querySelector('.fa-moon');
let isDayMode = true;
const ambientLight = new THREE.AmbientLight(0xe7e7e7, 1.2);
scene.add(ambientLight);
switchButton.addEventListener('click', () => {
  if (isDayMode) {
    scene.remove(ambientLight);
    skyMaterial.color = nightColor;
    setTimeout(() => {
      moonIcon.style.display = 'inline';
      sunIcon.style.display = 'none';
    }, 300);
  } else {
    scene.add(ambientLight);
    skyMaterial.color = dayColor;
    setTimeout(() => {
      moonIcon.style.display = 'none';
      sunIcon.style.display = 'inline';
    }, 300);
  }
  isDayMode = !isDayMode;
});

const fogColor = 0xCCCCCC; // Adjust the color as needed
const fogNear = 400; // Adjust the near and far values as needed
const fogFar = 1000;
const fog = new THREE.Fog(fogColor, fogNear, fogFar);
scene.fog = fog;

// Texture loader
const loader = new THREE.TextureLoader()
const texture = loader.load('/Grass 8.png')
const displacementMap = loader.load('/7.jpg');

// Terrain
const terrainGeometry = new THREE.PlaneGeometry(700, 700, 100, 100);
const terrainMaterial = new THREE.MeshPhongMaterial({
   color: 0x88aa88,
   wireframe: false,
   map: texture,
   displacementMap: displacementMap,
   displacementScale: 140,
   fog: true,
   });
const terrain = new THREE.Mesh(terrainGeometry, terrainMaterial);
terrain.rotation.x = -Math.PI / 2;
terrain.position.y = 0;
scene.add(terrain);

// Create a second particle
const particleGeometry2 = new THREE.BufferGeometry();
const particlePosition2 = new Float32Array([116,72, -64]);
const particleSize2 = new Float32Array([10]);

particleGeometry2.setAttribute('position', new THREE.BufferAttribute(particlePosition2, 3));
particleGeometry2.setAttribute('size', new THREE.BufferAttribute(particleSize2, 1));

const particleMaterial2 = new THREE.PointsMaterial({
  color: 0xFFFF00,
  sizeAttenuation: false, 
  size: 60,
  map: new THREE.TextureLoader().load('/particles.png'), 
  blending: THREE.AdditiveBlending, 
  depthWrite: false, 
  transparent: true,
});
const particleSystem2 = new THREE.Points(particleGeometry2, particleMaterial2);
scene.add(particleSystem2);

const loadingManager = new THREE.LoadingManager();

function hideLoadingScreen() {
  const loadingScreen = document.querySelector('.loading-screen');
  if (loadingScreen) {
    loadingScreen.style.display = 'none';
  }
}
// 1 GLTF Model asian house
const gltfLoader = new GLTFLoader(loadingManager);
function loadAndAddModel(modelUrl, position, scale, rotation = 0) {
  gltfLoader.load(modelUrl.href, function (gltf) {
    const model = gltf.scene;
    model.scale.set(scale, scale, scale);
    model.rotation.y = rotation; 
    model.position.copy(position);
    scene.add(model);
    modelIsLoaded = true;
    if (animationIsFinished && modelIsLoaded) {
      cameraAnimation();
      setTimeout(hideLoadingScreen, 3000);
    }
  });
}

const models = [
  { url: new URL('../assets/untitled.glb', import.meta.url),
   scale: 4, rotation: Math.PI / 3,
   position: new THREE.Vector3(210, 80, 160) },
  { url: new URL('../assets/market.glb', import.meta.url),
   scale: 40, rotation: Math.PI / -5,
   position: new THREE.Vector3(18, 38, -185) },
  { url: new URL('../assets/threehouse.glb', import.meta.url),
   scale: 5, position: new THREE.Vector3(-27, 20, 130) },
  { url: new URL('../assets/threehouse3.glb', import.meta.url),
   scale: 3, rotation: Math.PI / 5, 
   position: new THREE.Vector3(-107, 58, -136) },
  //  1
   { url: new URL('../assets/trees.glb', import.meta.url),
   scale: 0.25, rotation: Math.PI / 3,
   position: new THREE.Vector3(-15, 58, -255) },
  // 2
   { url: new URL('../assets/trees.glb', import.meta.url),
   scale: 0.25, rotation: Math.PI / 1,
   position: new THREE.Vector3(-140, 65, -270) },
  // // 3
   { url: new URL('../assets/trees.glb', import.meta.url),
   scale: 0.25,rotation: Math.PI / 1,
   position: new THREE.Vector3( -165, 66, -4) },
  // // 4
   { url: new URL('../assets/trees.glb', import.meta.url),
   scale: 0.30,rotation: Math.PI / 2,
   position: new THREE.Vector3(-275, 63, -100) },
  // 5
   { url: new URL('../assets/trees.glb', import.meta.url),
   scale: 0.32,rotation: Math.PI / 2,
   position: new THREE.Vector3(165, 63, 98) },
  // // 6
   { url: new URL('../assets/trees.glb', import.meta.url),
   scale: 0.28,
   position: new THREE.Vector3(24, 72, 274) },
  // //  7
  { url: new URL('../assets/trees.glb', import.meta.url),
   scale: 0.25,rotation: Math.PI / 2,
   position: new THREE.Vector3(262, 58, 280) },
  //  9
  { url: new URL('../assets/bridge.glb', import.meta.url),
   scale: 0.60,
   position: new THREE.Vector3(-150, 50, 31) },
  // //  10
  { url: new URL('../assets/bridge2.glb', import.meta.url),
   scale: 9,rotation: Math.PI / 1,
   position: new THREE.Vector3(132, 20, -110) },
  // //  11
  { url: new URL('../assets/light1.glb', import.meta.url),
  scale: 1,rotation: Math.PI / 1,
  position: new THREE.Vector3(116, 45, -64) },
];
let loadedModels = 0;

function onModelLoaded() {
  loadedModels++;
  if (loadedModels === models.length) {
    onLoadingComplete(); // All models loaded, remove loading text
  }
}
for (const modelData of models) {
  loadAndAddModel(modelData.url, modelData.position, modelData.scale, modelData.rotation, onModelLoaded);
}

const tl = gsap.timeline();
const duration = 5;
const ease = 'none';
let modelIsLoaded = false;
let animationIsFinished = false;
const initialCameraPosition = { x: 250, y: 200, z: -340 };
function cameraAnimation() {
  if (!animationIsFinished) {
    animationIsFinished = true;

    // Define the initial camera position
    const initialCameraPosition = { x: 250, y: 200, z: -340 };
    tl.to(initialCameraPosition, {
      x: 200,
      duration,
      ease,
      onUpdate: function () {
        camera.position.set(initialCameraPosition.x, initialCameraPosition.y, initialCameraPosition.z);
        camera.lookAt(0, 0, 0);
},}).to(
      initialCameraPosition,
      {
        y: 250,
        z: 350,
        duration,
        ease,
        onUpdate: function () {
          camera.position.set(initialCameraPosition.x, initialCameraPosition.y, initialCameraPosition.z);
          camera.lookAt(0, 0, 0);
        },},5).to(
      initialCameraPosition,
      {
        x: -80,
        y: 150,
        z: 400,
        duration,
        ease,
        onUpdate: function () {
          camera.position.set(initialCameraPosition.x, initialCameraPosition.y, initialCameraPosition.z);
          camera.lookAt(0, 0, 0);
        },},8).to(
      initialCameraPosition,
      {
        x: -180,
        y: 150,
        z: 230,
        duration,
        ease,
        onUpdate: function () {
          camera.position.set(initialCameraPosition.x, initialCameraPosition.y, initialCameraPosition.z);
          camera.lookAt(0, 0, 0);
        },},8).to(camera.position,{
      x: 290,
      y: 130,
      z: 200,
      duration,
      ease,
      onUpdate: function(){
        camera.lookAt(0,0,0);
      }},14)}}

// RENDER
function animate() {
  requestAnimationFrame(animate);
  controls.update();
  water.material.uniforms.time.value += 1.0 / 60.0;
    const positions = particleSystem.geometry.attributes.position.array;
    const sizes = particleSystem.geometry.attributes.size.array;
    for (let i = 0; i < positions.length; i += 3) {
      positions[i] += Math.random() * 2 - 1;
      positions[i + 1] += Math.random() * 2 - 1;
      positions[i + 2] += Math.random() * 2 - 1;
      sizes[i / 3] = Math.random() * 20 + 5;
    }
    particleSystem.geometry.attributes.position.needsUpdate = true;
    particleSystem.geometry.attributes.size.needsUpdate = true;
    updateCameraPosition();
    cameraAnimation();
  renderer.render(scene, camera);
  const cameraMatrix = camera.matrixWorld;
  const cameraPosition = new THREE.Vector3();
  cameraPosition.setFromMatrixPosition(cameraMatrix);
  listener.position.copy(cameraPosition);
}
animate();

window.addEventListener('resize', function () {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(window.innerWidth, window.innerHeight);
});